import { storageProxy } from '@/utils/cache'
import { ref } from 'vue'
import { useBaseStoreWithOut } from '@/store-pinia/modules/base'
import {
  getPhysicalWarehouseLabelName,
  getRegionWarehouseLabelName,
} from '@/composables/usePhysicalWarehouse'
import { getWarehouseCode } from '@/utils/auth'

const enum CacheKeys {
  REMEMBER_MY_CHOICE_WAREHOUSE = 'remember_my_choice_warehouse',
  REMEMBER_MY_CHOICE_WAREHOUSE_LOGIN = 'remember_my_choice_warehouse_login',
  WAREHOUSE_CODE_CHOSE = 'wp_code',
  WAREHOUSE_HAS_CHOSE = 'warehouse_has_chose',
}

export function useIsShowPopChoiseWarehouseCode(userCode: string) {
  const getRememberCacheLoginKey = () =>
    `${CacheKeys.REMEMBER_MY_CHOICE_WAREHOUSE_LOGIN}_${userCode.toLowerCase()}`
  const getRememberCacheLogin = () => storageProxy.get(getRememberCacheLoginKey()) as boolean
  const setRememberCacheLogin = (isRemember: boolean) => {
    isRememberChoiceLoginRef.value = isRemember
    storageProxy.set(getRememberCacheLoginKey(), isRemember)
  }
  const isRememberChoiceLoginRef = ref(getRememberCacheLogin() || false)

  return { setRememberCacheLogin, isRememberChoiceLoginRef }
}

/**
 * 仓库切换
 */
export function useWarehouseSwitch(userCode: string) {
  const baseStore = useBaseStoreWithOut()

  const getRememberCacheKey = () => `${CacheKeys.REMEMBER_MY_CHOICE_WAREHOUSE}_${userCode}`
  const getChoseCacheKey = () => `${CacheKeys.WAREHOUSE_CODE_CHOSE}_${userCode}`
  const getHasChoseCacheKey = () => `${CacheKeys.WAREHOUSE_HAS_CHOSE}_${userCode}`

  const getRememberCache = () => storageProxy.get(getRememberCacheKey()) as boolean
  const setRememberCache = (isRemember: boolean) => {
    isRememberChoiceRef.value = isRemember
    storageProxy.set(getRememberCacheKey(), isRemember)
  }
  const isRememberChoiceRef = ref(getRememberCache() || false)

  const setGlobalWarehouseChoseCache = (warehouseCode: string) => {
    if (!warehouseCode) {
      return storageProxy.remove(CacheKeys.WAREHOUSE_CODE_CHOSE)
    }
    storageProxy.set(CacheKeys.WAREHOUSE_CODE_CHOSE, warehouseCode)
  }

  const getWarehouseChoseCache = () => storageProxy.get(getChoseCacheKey()) as string
  const setWarehouseChoseCache = (warehouseCode: string) => {
    warehouseChoseRef.value = warehouseCode
    storageProxy.set(getChoseCacheKey(), warehouseCode)
    setGlobalWarehouseChoseCache(warehouseCode)
  }
  const clearWarehouseChoseCache = () => {
    storageProxy.remove(getChoseCacheKey())
    storageProxy.remove(CacheKeys.WAREHOUSE_CODE_CHOSE)
  }

  // const getWarehouseHasChoseCache = () => (storageProxy.get(getHasChoseCacheKey()) || '') as string

  const getWarehouseHasChoseCache = () => {
    if (getWarehouseChoseCache()) {
      return getPhysicalWarehouseLabelName(getWarehouseChoseCache())
    } else {
      return getRegionWarehouseLabelName(getWarehouseCode())
    }
  }

  const getChoiseWpcode = () => (storageProxy.get(getChoseCacheKey()) || '') as string
  const warehouseHasChoseRef = ref(getWarehouseHasChoseCache())
  const setWarehouseHasChoseCache = (warehouse: string) => {
    storageProxy.set(getHasChoseCacheKey(), warehouse)
    baseStore.setChoseWarehouse(warehouse)
  }

  const warehouseChoseRef = ref(getWarehouseChoseCache())

  setGlobalWarehouseChoseCache(warehouseChoseRef.value)
  baseStore.setChoseWarehouse(warehouseHasChoseRef.value)

  return {
    getChoiseWpcode,
    isRememberChoiceRef,
    setRememberCache,
    warehouseHasChoseRef,
    setWarehouseHasChoseCache,

    warehouseChoseRef,
    setWarehouseChoseCache,
    clearWarehouseChoseCache,
  }
}
